import axios from 'axios'
import helper from './helper'

const base_url = process.env.VUE_APP_API_URL

const api = ({...params}) => {
  const token = helper.getAccessToken()
  const method = params.method
  const url    = params.url
  const data   = params.data != null ? params.data : ''
  const config = { headers: {} }

  if (params.config == 'form-data') config.headers["Content-Type"] = "multipart/form-data"

  if (params.config == 'form-data-edit') config.headers["Content-Type"] = "application/x-www-form-urlencoded"
    
  if (token) config.headers.Authorization = `Bearer ${token}`
  else delete config.headers.Authorization

  // alert(config.headers.Authorization)
  
  if (method === 'get') {
    return axios.get(base_url + url, config)
  }

  if (method === 'post') {
    return axios.post(base_url+url, data, config)
  }

  if (method === 'put') {
    return axios.put(base_url+url, data, config)
  }

  if (method === 'delete') {
    return axios.delete(base_url+url, config)
  }
}

export default api